import { Component, inject } from '@angular/core';
import { EEntityType, ERelationType } from '@web/dtos';
import { Dialog, IDialogData } from '../dialog';
import { DialogComponent } from '../dialog/dialog.component';
import { ButtonComponent } from '../../feedback/button/button.component';
import { FilterTextsPipe } from '../../../pipes/filterTexts/filterTexts.pipe';
import { LanguagePipe } from '../../../pipes/language/language.pipe';
import { ToFontSizePipe } from '../../../pipes/to-font-size/to-font-size.pipe';
import { WebTextStore } from '../../../services/api/text/web-text-store.service';
import { CorporateDesignService } from '../../../services/corporate-design/corporate-design.service';
import { AuthProviderFactory } from '../../../services/auth/auth-provider.factory';
import { AuthProvider } from '../../../services/auth/auth.provider';
import { OrderDirectTicketSupportService } from '../../../services/support/order-ticket-support/order-direct-ticket-support.service';

export interface ITicketAuthChoiceDialogData extends IDialogData {
  ticketUrl: string;
}

@Component({
  selector: 'aw-ticket-auth-choice-dialog',
  imports: [
    DialogComponent,
    ButtonComponent,
    FilterTextsPipe,
    LanguagePipe,
    ToFontSizePipe,
  ],
  templateUrl: './ticket-auth-choice-dialog.component.html',
})
export class TicketAuthChoiceDialogComponent extends Dialog<ITicketAuthChoiceDialogData> {
  private readonly auth: AuthProvider =
    inject(AuthProviderFactory).getProvider('shop');
  private readonly orderTicketService: OrderDirectTicketSupportService = inject(
    OrderDirectTicketSupportService
  );

  protected readonly textStore: WebTextStore = inject(WebTextStore);
  protected readonly corporateDesignService: CorporateDesignService = inject(
    CorporateDesignService
  );
  protected readonly EEntityType: typeof EEntityType = EEntityType;
  protected readonly ERelationType: typeof ERelationType = ERelationType;

  protected login(): void {
    const ticketUrl = this.data?.ticketUrl;
    if (!ticketUrl) {
      console.error('Login nicht möglich: Ticket-URL fehlt');
      return;
    }

    this.auth.login(ticketUrl);
    this.dialogRef.close();
  }

  protected continueAsGuest(): void {
    this.orderTicketService.goToDirectTicket(this.data.ticketUrl);
    this.dialogRef.close();
  }
}
